export const AllCompanyOption = [
    {
        "user_email": "nyb.dev@gmail.com",
        "user_status": true,
        "company_id": 9,
        "id": 13,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "nyb.dev@gmail.com",
            "company_name": "nyb",
            "company_description": "https://newyorkburrito.co.in/wp-content/uploads/2020/10/NYBC-Logo-White-02-e1602136565282.png",
            "company_address": "Test 4",
            "company_pin_code": "145872",
            "company_website": "Test 4",
            "company_contact": "452103",
            "company_poc": "Test 4",
            "company_poc_contact": "Test 4",
            "deployment_region": "ap-south-1",
            "id": 9,
            "created_date": "2021-03-09T14:41:27",
            "updated_date": "2021-03-09T14:41:27"
        },
        "locations": [],
        "companies": [],
        "created_date": "2021-03-05T12:01:06",
        "updated_date": "2021-03-05T12:01:06"
    },
    {
        "user_email": "ravin_admin@tusker.ai",
        "user_status": true,
        "company_id": 52,
        "id": 62,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "ravin_admin@tusker.ai",
            "company_name": "ravin",
            "company_description": "ravin",
            "company_address": "ravin",
            "company_pin_code": "382481",
            "company_website": "ravin.com",
            "company_contact": "8000344625",
            "company_poc": "123",
            "company_poc_contact": "45654654656",
            "deployment_region": "ap-south-1",
            "id": 52,
            "created_date": "2021-10-23T12:03:57",
            "updated_date": "2021-10-23T12:03:57"
        },
        "locations": [],
        "companies": [],
        "created_date": "2021-10-23T12:03:58",
        "updated_date": "2021-10-23T12:03:58"
    },
    {
        "user_email": "labs_admin@tusker.ai",
        "user_status": false,
        "company_id": 58,
        "id": 69,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "labs@gmail.com",
            "company_name": "labs",
            "company_description": "labs description",
            "company_address": "gujrat",
            "company_pin_code": "382480",
            "company_website": "https://www.labs.com",
            "company_contact": "1234567891",
            "company_poc": "test",
            "company_poc_contact": "1234567890",
            "deployment_region": "ap-south-1",
            "id": 58,
            "created_date": "2022-03-28T07:54:13",
            "updated_date": "2022-03-28T07:54:13"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-03-28T07:54:15",
        "updated_date": "2022-03-28T07:54:15"
    },
    {
        "user_email": "holiday_inn_admin@tusker.ai",
        "user_status": true,
        "company_id": 59,
        "id": 70,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "holiday_inn@gmail.com",
            "company_name": "holidayinn",
            "company_description": "holiday_inn description",
            "company_address": "usa",
            "company_pin_code": "382480",
            "company_website": "https://www.holiday_inn.com",
            "company_contact": "1234567891",
            "company_poc": "test",
            "company_poc_contact": "1234567890",
            "deployment_region": "ap-south-1",
            "id": 59,
            "created_date": "2022-03-28T08:31:48",
            "updated_date": "2022-03-28T08:31:48"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-03-28T08:31:49",
        "updated_date": "2022-03-28T08:31:49"
    },
    {
        "user_email": "airport_admin@tusker.ai",
        "user_status": false,
        "company_id": 60,
        "id": 73,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "airport_admin@tusker.ai",
            "company_name": "airport",
            "company_description": "sardar vallabhbhai international airport",
            "company_address": "ahmedabad",
            "company_pin_code": "382480",
            "company_website": "https://www.airport.com",
            "company_contact": "1234567893",
            "company_poc": "test",
            "company_poc_contact": "1234567892",
            "deployment_region": "ap-south-1",
            "id": 60,
            "created_date": "2022-03-30T13:14:21",
            "updated_date": "2022-03-30T13:14:21"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-03-30T13:14:23",
        "updated_date": "2022-03-30T13:14:23"
    },
    {
        "user_email": "waghbakri_admin@tusker.ai",
        "user_status": true,
        "company_id": 61,
        "id": 75,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "waghbakri@gmail.com",
            "company_name": "waghbakri",
            "company_description": "Tea Company",
            "company_address": "Ahmedabad",
            "company_pin_code": "380006",
            "company_website": "www.waghbakritea.com",
            "company_contact": "7894561231",
            "company_poc": "Tea Company",
            "company_poc_contact": "7894561231",
            "deployment_region": "ap-south-1",
            "id": 61,
            "created_date": "2022-05-25T13:48:06",
            "updated_date": "2022-05-25T13:48:06"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-05-25T13:48:07",
        "updated_date": "2022-05-25T13:48:07"
    },
    {
        "user_email": "buldon_admin@tusker.ai",
        "user_status": false,
        "company_id": 62,
        "id": 78,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "buldon_house@gmail.com",
            "company_name": "buldonhouse",
            "company_description": "buldon_house",
            "company_address": "buldon_house",
            "company_pin_code": "382481",
            "company_website": "buldon_house.com",
            "company_contact": "8000344625",
            "company_poc": "123",
            "company_poc_contact": "45654654656",
            "deployment_region": "ap-south-1",
            "id": 62,
            "created_date": "2022-07-07T14:08:22",
            "updated_date": "2022-07-07T14:08:22"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-07-07T14:08:23",
        "updated_date": "2022-07-07T14:08:23"
    },
    {
        "user_email": "nirma_admin@tusker.ai",
        "user_status": true,
        "company_id": 63,
        "id": 79,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "nirma@gmail.com",
            "company_name": "nirma",
            "company_description": "This client is Nirma university.",
            "company_address": "Ahmedabad",
            "company_pin_code": "380008",
            "company_website": "nirma.edu.com",
            "company_contact": "8000344625",
            "company_poc": "123",
            "company_poc_contact": "45654654656",
            "deployment_region": "ap-south-1",
            "id": 63,
            "created_date": "2022-07-26T12:19:46",
            "updated_date": "2022-07-26T12:19:46"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-07-26T12:19:47",
        "updated_date": "2022-07-26T12:19:47"
    },
    {
        "user_email": "user_admin@tusker.ai",
        "user_status": false,
        "company_id": 65,
        "id": 82,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "ceattyer@gmail.com",
            "company_name": "user",
            "company_description": "Tyer",
            "company_address": "Ahmedabad",
            "company_pin_code": "380013",
            "company_website": "www.ceattyre.com",
            "company_contact": "7894561231",
            "company_poc": "Tyre",
            "company_poc_contact": "7894561231",
            "deployment_region": "ap-south-1",
            "id": 65,
            "created_date": "2022-12-06T14:39:03",
            "updated_date": "2022-12-06T14:39:03"
        },
        "locations": [],
        "companies": [],
        "created_date": "2022-12-06T14:39:04",
        "updated_date": "2022-12-06T14:39:04"
    },
    {
        "user_email": "coronaremedies_admin@tusker.ai",
        "user_status": false,
        "company_id": 68,
        "id": 85,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "coronaremedies@gmail.com",
            "company_name": "coronaremedies",
            "company_description": "Corona Remedies",
            "company_address": "Ahmedabad",
            "company_pin_code": "380015",
            "company_website": "coronaremedies.com",
            "company_contact": "7589641231",
            "company_poc": "7589641231",
            "company_poc_contact": "7589641231",
            "deployment_region": "ap-south-1",
            "id": 68,
            "created_date": "2023-04-04T05:49:57",
            "updated_date": "2023-04-04T05:49:57"
        },
        "locations": [],
        "companies": [],
        "created_date": "2023-04-04T05:49:58",
        "updated_date": "2023-04-04T05:49:58"
    },
    {
        "user_email": "ludhiyana_admin@tusker.ai",
        "user_status": false,
        "company_id": 71,
        "id": 88,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "lidhiyana@gmail.com",
            "company_name": "ludhiyana",
            "company_description": "lidhiyana",
            "company_address": "lidhiyana",
            "company_pin_code": "380013",
            "company_website": "lidhiyana@gmail.com",
            "company_contact": "7459863210",
            "company_poc": "ludhiyana",
            "company_poc_contact": "7459863210",
            "deployment_region": "ap-south-1",
            "id": 71,
            "created_date": "2023-04-25T13:57:20",
            "updated_date": "2023-04-25T13:57:20"
        },
        "locations": [],
        "companies": [],
        "created_date": "2023-04-25T13:57:21",
        "updated_date": "2023-04-25T13:57:21"
    },
    {
        "user_email": "vadilal_admin@tusker.ai",
        "user_status": true,
        "company_id": 70,
        "id": 87,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "vadilal_admin@tusker.ai",
            "company_name": "vadilal",
            "company_description": "Vadilal Group",
            "company_address": "Bopal Ambli Road,\nAhmedabad ",
            "company_pin_code": "380054",
            "company_website": "https://www.vadilalicecreams.com/",
            "company_contact": "7930921200",
            "company_poc": "7930921200",
            "company_poc_contact": "7930921200",
            "deployment_region": "ap-south-1",
            "id": 70,
            "created_date": "2023-04-14T12:04:59",
            "updated_date": "2023-04-14T12:04:59"
        },
        "locations": [],
        "companies": [],
        "created_date": "2023-04-14T12:05:00",
        "updated_date": "2023-04-14T12:05:00"
    },
    {
        "user_email": "sahanacensorboard@gmail.com",
        "user_status": true,
        "company_id": 73,
        "id": 90,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "vinay.kaushal135@gmail.com",
            "company_name": "censor board",
            "company_description": "censor board",
            "company_address": "Vinay.Kaushal.Address",
            "company_pin_code": "363001",
            "company_website": "vinay.kaushal135@gmail.com",
            "company_contact": "8866154455",
            "company_poc": "445522",
            "company_poc_contact": "9455442784",
            "deployment_region": "ap-south-1",
            "id": 73,
            "created_date": "2023-08-29T06:24:28",
            "updated_date": "2023-08-29T06:24:28"
        },
        "locations": [],
        "companies": [],
        "created_date": "2023-08-29T06:24:29",
        "updated_date": "2023-08-29T06:24:29"
    },
    {
        "user_email": "edgenectar@tusker.ai",
        "user_status": false,
        "company_id": 74,
        "id": 91,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "edgenectar_demo@gmail.com",
            "company_name": "Edgenectar",
            "company_description": "edgenectar_demo@gmail.com",
            "company_address": "Ahmedabad",
            "company_pin_code": "380013",
            "company_website": "edgenectar_demo@gmail.com",
            "company_contact": "7894561231",
            "company_poc": "Demo company",
            "company_poc_contact": "7894561231",
            "deployment_region": "ap-south-1",
            "id": 74,
            "created_date": "2023-12-01T11:05:52",
            "updated_date": "2023-12-01T11:05:52"
        },
        "locations": [],
        "companies": [],
        "created_date": "2023-12-01T11:05:53",
        "updated_date": "2023-12-01T11:05:53"
    },
    {
        "user_email": "oman_admin@gmail.com",
        "user_status": false,
        "company_id": 78,
        "id": 95,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "oman@gmail.com",
            "company_name": "oman",
            "company_description": "Oman",
            "company_address": "Ahmedabad",
            "company_pin_code": "380000",
            "company_website": "Oman@Admin",
            "company_contact": "0000000000",
            "company_poc": "0000000000",
            "company_poc_contact": "0000000000",
            "deployment_region": "ap-south-1",
            "id": 78,
            "created_date": "2024-03-21T09:28:26",
            "updated_date": "2024-03-21T09:28:26"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-03-21T09:28:27",
        "updated_date": "2024-03-21T09:28:27"
    },
    {
        "user_email": "rpg_admin@tusker.ai",
        "user_status": true,
        "company_id": 79,
        "id": 97,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "rpg_admin@tusker.ai",
            "company_name": "rpg",
            "company_description": "RPG",
            "company_address": "Naigaon East, Vasai-Virar, Bapane, Maharashtra 401208",
            "company_pin_code": "401208",
            "company_website": "https://www.rpggroup.com",
            "company_contact": "7456312192",
            "company_poc": "RPG",
            "company_poc_contact": "7456312192",
            "deployment_region": "ap-south-1",
            "id": 79,
            "created_date": "2024-04-04T07:17:39",
            "updated_date": "2024-04-04T07:17:39"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-04-04T07:17:40",
        "updated_date": "2024-04-04T07:17:40"
    },
    {
        "user_email": "silveroak@tusker.ai",
        "user_status": true,
        "company_id": 80,
        "id": 98,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "silveroak@gmail.com",
            "company_name": "silveroak",
            "company_description": "silveroak",
            "company_address": "silveroak",
            "company_pin_code": "380013",
            "company_website": "silveroakuni.ac.in",
            "company_contact": "9854612300",
            "company_poc": "silveroak",
            "company_poc_contact": "9854612300",
            "deployment_region": "ap-south-1",
            "id": 80,
            "created_date": "2024-06-21T09:00:41",
            "updated_date": "2024-06-21T09:00:41"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-06-21T09:00:42",
        "updated_date": "2024-06-21T09:00:42"
    },
    {
        "user_email": "army_admin@tusker.ai",
        "user_status": true,
        "company_id": 81,
        "id": 99,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "army@gmail.com",
            "company_name": "army",
            "company_description": "army",
            "company_address": "army",
            "company_pin_code": "380000",
            "company_website": "army",
            "company_contact": "9876543210",
            "company_poc": "9876543210",
            "company_poc_contact": "9876543210",
            "deployment_region": "ap-south-1",
            "id": 81,
            "created_date": "2024-09-23T06:21:04",
            "updated_date": "2024-09-23T06:21:04"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-09-23T06:21:05",
        "updated_date": "2024-09-23T06:21:05"
    },
    {
        "user_email": "topspin_admin@tusker.ai",
        "user_status": false,
        "company_id": 82,
        "id": 101,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "topspin@tusker.ai",
            "company_name": "topspin ",
            "company_description": "Ahmedabad cafe",
            "company_address": "101/3, Devarc Mall, Sarkhej - Gandhinagar Hwy, Ramdev Nagar, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://www.topspinclub.in/",
            "company_contact": "09930663000",
            "company_poc": "Chair occupancy ",
            "company_poc_contact": "09930663000",
            "deployment_region": "ap-south-1",
            "id": 82,
            "created_date": "2024-10-14T13:10:37",
            "updated_date": "2024-10-14T13:10:37"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-10-14T13:10:38",
        "updated_date": "2024-10-14T13:10:38"
    },
    {
        "user_email": "fieldai_admin@tusker.ai",
        "user_status": false,
        "company_id": 83,
        "id": 103,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "fieldai@gmail.com",
            "company_name": "fieldai",
            "company_description": "fieldai",
            "company_address": "USA",
            "company_pin_code": "380013",
            "company_website": "https://fieldai.com/",
            "company_contact": "7894561231",
            "company_poc": "Demo company",
            "company_poc_contact": "7894561231",
            "deployment_region": "ap-south-1",
            "id": 83,
            "created_date": "2024-10-28T06:30:55",
            "updated_date": "2024-10-28T06:30:55"
        },
        "locations": [
            {
                "location_name": "California",
                "company_id": 83,
                "status": true,
                "id": 89,
                "created_date": "2024-10-28T07:04:32",
                "updated_date": "2024-10-28T14:11:20"
            }
        ],
        "companies": [],
        "created_date": "2024-10-28T06:30:56",
        "updated_date": "2024-10-28T06:30:56"
    },
    {
        "user_email": "ai_port_admin@tusker.ai",
        "user_status": true,
        "company_id": 84,
        "id": 104,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "ai_port_admin@tusker.ai",
            "company_name": "ai port",
            "company_description": "bangalore",
            "company_address": "bangalore",
            "company_pin_code": "530068",
            "company_website": "https://www.searates.com/port/bangalore_in",
            "company_contact": "08022867990",
            "company_poc": "9855368585",
            "company_poc_contact": "85522685454",
            "deployment_region": "ap-south-1",
            "id": 84,
            "created_date": "2024-11-15T07:30:23",
            "updated_date": "2024-11-15T07:30:23"
        },
        "locations": [
            {
                "location_name": "Mumbai",
                "company_id": 84,
                "status": true,
                "id": 90,
                "created_date": "2024-11-15T07:44:06",
                "updated_date": "2024-12-23T09:29:31"
            }
        ],
        "companies": [],
        "created_date": "2024-11-15T07:30:24",
        "updated_date": "2024-11-15T07:30:24"
    },
    {
        "user_email": "warehouse_admin@tusker.ai",
        "user_status": false,
        "company_id": 85,
        "id": 105,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "warehouse_admin@tusker.ai",
            "company_name": "warehouse",
            "company_description": "warehouse Gandhinagar",
            "company_address": "warehouse Gandhinagar",
            "company_pin_code": "980006",
            "company_website": "warehouse_admin@tusker.ai",
            "company_contact": "8546874856",
            "company_poc": "Demo company",
            "company_poc_contact": "7894561231",
            "deployment_region": "ap-south-1",
            "id": 85,
            "created_date": "2024-11-28T10:47:38",
            "updated_date": "2024-11-28T10:47:38"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-11-28T10:47:39",
        "updated_date": "2024-11-28T10:47:39"
    },
    {
        "user_email": "ministry_of_petroleum_admin@tusker.ai",
        "user_status": false,
        "company_id": 86,
        "id": 106,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "ministry_of_petroleum_admin@tusker.ai",
            "company_name": "ministry of petroleum",
            "company_description": "Ministry of Petroleum",
            "company_address": "Ahmedabad",
            "company_pin_code": "380015",
            "company_website": "https://mopng.gov.in/en",
            "company_contact": "9854612300",
            "company_poc": "Smoking",
            "company_poc_contact": "9854612300",
            "deployment_region": "ap-south-1",
            "id": 86,
            "created_date": "2024-12-03T05:40:24",
            "updated_date": "2024-12-03T05:40:24"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-12-03T05:40:25",
        "updated_date": "2024-12-03T05:40:25"
    },
    {
        "user_email": "hello@newra.ai",
        "user_status": true,
        "company_id": 87,
        "id": 107,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "demo@tusker.ai",
            "company_name": "NewRA Demo",
            "company_description": "demo purpose",
            "company_address": "Ahmedabad",
            "company_pin_code": "530068",
            "company_website": "https://beta.tusker.ai/#/auth/registration",
            "company_contact": "08022867990",
            "company_poc": "9855368585",
            "company_poc_contact": "85522685454",
            "deployment_region": "ap-south-1",
            "id": 87,
            "created_date": "2024-12-06T06:40:29",
            "updated_date": "2024-12-06T06:40:29"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-12-06T06:40:30",
        "updated_date": "2024-12-06T06:40:30"
    },
    {
        "user_email": "craneadmin@tusker.ai",
        "user_status": false,
        "company_id": 89,
        "id": 109,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "craneadmin@tusker.ai",
            "company_name": "crane",
            "company_description": "craneadmin@tusker.ai",
            "company_address": "craneadmin@tusker.ai",
            "company_pin_code": "530068",
            "company_website": "https://www.searates.com/port/bangalore_in",
            "company_contact": "08022867990",
            "company_poc": "9855368585",
            "company_poc_contact": "85522685454",
            "deployment_region": "ap-south-1",
            "id": 89,
            "created_date": "2024-12-20T12:13:05",
            "updated_date": "2024-12-20T12:13:05"
        },
        "locations": [],
        "companies": [],
        "created_date": "2024-12-20T12:13:06",
        "updated_date": "2024-12-20T12:13:06"
    },
    {
        "user_email": "nobleuniversityadmin@tusker.ai",
        "user_status": false,
        "company_id": 90,
        "id": 116,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "info@nobleuniversity.ac.inrsity.ac.in",
            "company_name": "noble",
            "company_description": "Noble University ",
            "company_address": "Junagadh",
            "company_pin_code": "362310",
            "company_website": "https://nobleuniversity.ac.in/contact-us/",
            "company_contact": "9824299961",
            "company_poc": "Noble University",
            "company_poc_contact": "9824299961",
            "deployment_region": "ap-south-1",
            "id": 90,
            "created_date": "2025-01-09T12:00:05",
            "updated_date": "2025-01-09T12:00:05"
        },
        "locations": [],
        "companies": [],
        "created_date": "2025-01-09T12:00:06",
        "updated_date": "2025-01-09T12:00:06"
    },
    {
        "user_email": "megawide@hiro.ai",
        "user_status": true,
        "company_id": 96,
        "id": 123,
        "roles": [
            {
                "role": "admin",
                "id": 2
            }
        ],
        "company": {
            "company_email": "megawide@tusker.ai",
            "company_name": "megawide",
            "company_description": "megawide",
            "company_address": "philippines",
            "company_pin_code": "380006",
            "company_website": "https://megabytebohol.com/",
            "company_contact": "0384113164",
            "company_poc": "abcd",
            "company_poc_contact": "1234567890",
            "deployment_region": "ap-south-1",
            "id": 96,
            "created_date": "2025-04-25T13:44:12",
            "updated_date": "2025-04-25T13:44:12"
        },
        "locations": [],
        "companies": [],
        "created_date": "2025-04-25T13:44:13",
        "updated_date": "2025-04-25T13:44:13"
    }
]

export const AllLocationOption = [
    {
        "location_name": "Admin",
        "company_id": 79,
        "status": true,
        "id": 84,
        "created_date": "2024-04-04T07:19:49",
        "updated_date": "2024-12-23T12:46:38"
    },
    {
        "location_name": "Store",
        "company_id": 79,
        "status": true,
        "id": 96,
        "created_date": "2024-12-23T12:48:23",
        "updated_date": "2024-12-23T12:48:23"
    },
    {
        "location_name": "Gloves Production",
        "company_id": 79,
        "status": true,
        "id": 97,
        "created_date": "2024-12-23T12:48:35",
        "updated_date": "2024-12-23T12:48:35"
    },
    {
        "location_name": "GMDCA Production",
        "company_id": 79,
        "status": false,
        "id": 98,
        "created_date": "2024-12-23T12:48:48",
        "updated_date": "2024-12-23T12:48:48"
    },
    {
        "location_name": "Toolroom",
        "company_id": 79,
        "status": true,
        "id": 99,
        "created_date": "2024-12-23T12:49:10",
        "updated_date": "2024-12-23T12:49:10"
    },
    {
        "location_name": "Maintenance",
        "company_id": 79,
        "status": false,
        "id": 100,
        "created_date": "2024-12-23T12:49:19",
        "updated_date": "2024-12-23T12:49:19"
    }
]

export const AllCameraOption = [
    {
        "rtsp_url": "rtsp://admin:Dekhayu@3office@115.245.240.156:554/9/1",
        "process_fps": 1,
        "is_tcp": true,
        "camera_name": "Camera1",
        "camera_resolution": "640:640",
        "location_id": 1,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 1,
        "created_date": "2025-05-20T12:42:36",
        "updated_date": "2025-06-11T14:37:37",
        "location_details": {
            "location_name": "Admin",
            "id": 1,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Dekhayu@3office@115.245.240.156:554/9/1",
        "process_fps": 3,
        "is_tcp": true,
        "camera_name": "Camera2",
        "camera_resolution": "640:640",
        "location_id": 1,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 2,
        "created_date": "2025-05-20T12:43:53",
        "updated_date": "2025-05-24T13:15:41",
        "location_details": {
            "location_name": "Store",
            "id": 1,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Dekhayu@3office@115.245.240.156:554/9/1\n",
        "process_fps": 15,
        "is_tcp": true,
        "camera_name": "Camera3",
        "camera_resolution": "640:640",
        "location_id": 2,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 3,
        "created_date": "2025-05-20T12:44:07",
        "updated_date": "2025-05-20T12:44:07",
        "location_details": {
            "location_name": "Gloves Production",
            "id": 2,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:aip1.0@cctv@115.244.149.106:554/unicast/c1/s0/live",
        "process_fps": 60,
        "is_tcp": true,
        "camera_name": "Camera4",
        "camera_resolution": "640:640",
        "location_id": 1,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 11,
        "created_date": "2025-05-21T15:40:28",
        "updated_date": "2025-05-23T23:15:05",
        "location_details": {
            "location_name": "GMDCA Production",
            "id": 1,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Admin@123@43.251.217.146:1024/streaming/Channels/301",
        "process_fps": 60,
        "is_tcp": true,
        "camera_name": "Camera5",
        "camera_resolution": "640:640",
        "location_id": 2,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 12,
        "created_date": "2025-05-23T13:36:20",
        "updated_date": "2025-05-23T13:36:20",
        "location_details": {
            "location_name": "Admin",
            "id": 2,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Dekhayu%40403office@192.168.11.50:554/21/1",
        "process_fps": 50,
        "is_tcp": true,
        "camera_name": "Camera6",
        "camera_resolution": "640:640",
        "location_id": 6,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 13,
        "created_date": "2025-05-23T20:34:38",
        "updated_date": "2025-05-23T20:35:05",
        "location_details": {
            "location_name": "GMDCA Production",
            "id": 6,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Dekhayu%40403office@192.168.11.50:554/21/1",
        "process_fps": 50,
        "is_tcp": true,
        "camera_name": "Camera7",
        "camera_resolution": "640:640",
        "location_id": 7,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": "http://192.168.11.87:5000/video1",
        "id": 14,
        "created_date": "2025-05-23T20:44:05",
        "updated_date": "2025-05-23T20:44:22",
        "location_details": {
            "location_name": "Store",
            "id": 7,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Admin@123@43.251.217.146:1024/streaming/Channels/301",
        "process_fps": 60,
        "is_tcp": true,
        "camera_name": "cam6",
        "camera_resolution": "640:640",
        "location_id": 9,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": null,
        "id": 15,
        "created_date": "2025-05-28T18:33:02",
        "updated_date": "2025-05-28T18:34:26",
        "location_details": {
            "location_name": "Admin",
            "id": 9,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Admin@123@43.251.217.146:1024/streaming/Channels/301",
        "process_fps": 60,
        "is_tcp": true,
        "camera_name": "cam5",
        "camera_resolution": "640:640",
        "location_id": 9,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": null,
        "id": 16,
        "created_date": "2025-05-28T18:47:34",
        "updated_date": "2025-06-11T17:22:15",
        "location_details": {
            "location_name": "Gloves Production",
            "id": 9,
            "company_id": 1
        }
    },
    {
        "rtsp_url": "rtsp://admin:Admin@123@43.251.217.146:1024/streaming/Channels/301",
        "process_fps": 60,
        "is_tcp": true,
        "camera_name": "cam45",
        "camera_resolution": "640:640",
        "location_id": 2,
        "is_active": true,
        "is_processing": true,
        "status": true,
        "inference_url": null,
        "id": 17,
        "created_date": "2025-06-11T17:57:51",
        "updated_date": "2025-06-11T17:57:51",
        "location_details": {
            "location_name": "Store",
            "id": 2,
            "company_id": 1
        }
    },
]

export const AllSupervisorOption = [
    {
        "user_email": "ivssupervisor@tusker.ai",
        "status": true,
        "company_id": 1,
        "id": 3,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [
            {
                "location_name": "Admin",
                "company_id": 1,
                "id": 10,
                "created_date": "2025-06-11T06:32:15",
                "updated_date": "2025-06-11T06:32:15"
            },
            {
                "location_name": "Store",
                "company_id": 1,
                "id": 12,
                "created_date": "2025-06-18T05:37:46",
                "updated_date": "2025-06-18T06:14:01"
            },
            {
                "location_name": "Gloves Production",
                "company_id": 1,
                "id": 8,
                "created_date": "2025-05-28T12:58:20",
                "updated_date": "2025-06-18T06:17:34"
            },
            {
                "location_name": "GMDCA Production",
                "company_id": 1,
                "id": 2,
                "created_date": "2025-05-20T07:01:45",
                "updated_date": "2025-05-20T07:01:45"
            },
            {
                "location_name": "Toolroom",
                "company_id": 1,
                "id": 6,
                "created_date": "2025-05-23T15:01:27",
                "updated_date": "2025-05-23T15:02:02"
            },
            {
                "location_name": "Maintenance",
                "company_id": 1,
                "id": 7,
                "created_date": "2025-05-23T15:11:57",
                "updated_date": "2025-05-23T15:13:03"
            },
        ],
        "companies": [],
        "created_date": "2025-05-20T12:56:27",
        "updated_date": "2025-05-20T12:56:27"
    },
    {
        "user_email": "ivssupedfssddf@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 12,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [
            {
                "location_name": "Toolroom",
                "company_id": 1,
                "id": 1,
                "created_date": "2025-05-20T07:01:34",
                "updated_date": "2025-05-30T10:00:36"
            },
            {
                "location_name": "Store",
                "company_id": 1,
                "id": 2,
                "created_date": "2025-05-20T07:01:45",
                "updated_date": "2025-05-20T07:01:45"
            }
        ],
        "companies": [],
        "created_date": "2025-05-23T12:04:48",
        "updated_date": "2025-05-23T12:04:48"
    },
    {
        "user_email": "ivsasdsads@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 14,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [],
        "companies": [],
        "created_date": "2025-05-23T12:07:06",
        "updated_date": "2025-05-23T12:07:06"
    },
    {
        "user_email": "ivsadmin45645654@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 16,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [
            {
                "location_name": "Admin",
                "company_id": 1,
                "id": 1,
                "created_date": "2025-05-20T07:01:34",
                "updated_date": "2025-05-30T10:00:36"
            }
        ],
        "companies": [],
        "created_date": "2025-05-23T12:28:53",
        "updated_date": "2025-05-23T12:28:53"
    },
    {
        "user_email": "ivssuperadmin56768678678@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 17,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [],
        "companies": [],
        "created_date": "2025-05-23T12:30:03",
        "updated_date": "2025-05-23T12:30:03"
    },
    {
        "user_email": "ivssuperadmin1234@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 18,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [
            {
                "location_name": "Toolroom",
                "company_id": 1,
                "id": 2,
                "created_date": "2025-05-20T07:01:45",
                "updated_date": "2025-05-20T07:01:45"
            }
        ],
        "companies": [],
        "created_date": "2025-05-23T20:36:42",
        "updated_date": "2025-05-23T20:36:42"
    },
    {
        "user_email": "ivsadmin12323@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 19,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [],
        "companies": [],
        "created_date": "2025-05-23T20:47:00",
        "updated_date": "2025-05-23T20:47:00"
    },
    {
        "user_email": "ivssupppervisor123@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 20,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [],
        "companies": [],
        "created_date": "2025-05-23T20:53:54",
        "updated_date": "2025-05-23T20:53:54"
    },
    {
        "user_email": "ivssuperadmin123@tusker.ai",
        "status": false,
        "company_id": 1,
        "id": 21,
        "roles": [
            {
                "role": "supervisor",
                "id": 3
            }
        ],
        "company": {
            "company_email": "ivsadmin@gmail.com",
            "company_name": "IVS",
            "company_description": "IVS",
            "company_address": "305, Sigma Legacy, nr. Panjarapole Cross Road, Ambawadi, Ahmedabad, Gujarat",
            "company_pin_code": "380015",
            "company_website": "https://tusker.ai",
            "company_contact": "9898560255",
            "company_poc": "demo",
            "company_poc_contact": "989856",
            "deployment_region": "ap-south-1",
            "id": 1,
            "created_date": "2025-05-13T17:19:52",
            "updated_date": "2025-05-13T17:19:52"
        },
        "locations": [
            {
                "location_name": "Admin",
                "company_id": 1,
                "id": 9,
                "created_date": "2025-05-28T12:59:16",
                "updated_date": "2025-05-28T12:59:30"
            },
            {
                "location_name": "GMDCA Production",
                "company_id": 1,
                "id": 8,
                "created_date": "2025-05-28T12:58:20",
                "updated_date": "2025-06-18T06:17:34"
            }
        ],
        "companies": [],
        "created_date": "2025-05-28T18:52:47",
        "updated_date": "2025-05-28T18:52:47"
    },
]

export const AllModalOption = [
    {
        "model_name": "PPE Kit Detection",
        "model_description": "This model detects whether the person has applied a PPE kit or not and tells it's location.",
        "model_cpu_infer_speed": "0.11 ms",
        "model_gpu_infer_speed": "0.007 ms",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "14 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 3,
        "status": true,
        "id": 58,
        "created_date": "2021-01-24T18:32:25",
        "updated_date": "2021-01-24T18:32:25"
    },
    {
        "model_name": "Fire Smoke",
        "model_description": "Fire Smoke",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 88,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Mask Detection",
        "model_description": "This model detects whether the person has applied a mask on face or not and tells it's location.",
        "model_cpu_infer_speed": "0.11 ms",
        "model_gpu_infer_speed": "0.007 ms",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "15 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 4,
        "status": true,
        "id": 3,
        "created_date": "2021-01-24T18:32:25",
        "updated_date": "2021-01-24T18:32:25"
    },
    {
        "model_name": "person lying on the floor",
        "model_description": "person lying on the floor",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 89,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Person Detection Common",
        "model_description": "This model will detect persons from given input images. This is the advanced version of existing model",
        "model_cpu_infer_speed": "0.11 ms",
        "model_gpu_infer_speed": "0.007 ms",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "14 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 2,
        "status": true,
        "id": 57,
        "created_date": "2021-01-24T18:32:25",
        "updated_date": "2021-01-24T18:32:25"
    },
    {
        "model_name": "Person Detection",
        "model_description": "This model will detect a person from given input images.",
        "model_cpu_infer_speed": "0.11 ms",
        "model_gpu_infer_speed": "0.007 ms",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "13 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 3,
        "status": true,
        "id": 7,
        "created_date": "2021-01-24T18:32:25",
        "updated_date": "2021-01-24T18:32:25"
    },
    {
        "model_name": "security person",
        "model_description": "security person",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 90,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Stored product without pallate",
        "model_description": "Stored product without pallate",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 91,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Gate Open",
        "model_description": "Gate Open",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 92,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Shutter Operation",
        "model_description": "Shutter Operation",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 93,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "General Model",
        "model_description": "This is general model to detect common objects like cat, dog, car, etc.",
        "model_cpu_infer_speed": "0.11 ms",
        "model_gpu_infer_speed": "0.007 ms",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "14 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 5,
        "status": true,
        "id": 4,
        "created_date": "2021-01-24T18:32:25",
        "updated_date": "2021-01-24T18:32:25"
    },
    {
        "model_name": "Safety Shoes",
        "model_description": "Safety Shoes",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 94,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Safety Gloves",
        "model_description": "Safety Gloves",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 96,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Safety Goggles",
        "model_description": "Safety Goggles",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 97,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Safety Belt",
        "model_description": "Safety Belt",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 95,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    },
    {
        "model_name": "Vehicle Direction",
        "model_description": "Vehicle Direction",
        "model_cpu_infer_speed": "30 FPS",
        "model_gpu_infer_speed": "300 FPS",
        "model_version_id": "1",
        "model_accuracy": "90",
        "model_size": "20 MB",
        "model_depth": "x",
        "framework_version_number": "v1",
        "model_type_id": 1,
        "model_device_id": 1,
        "model_framework_id": 1,
        "model_category_id": 1,
        "status": true,
        "id": 99,
        "created_date": "2023-06-02T10:08:14",
        "updated_date": "2023-06-02T10:08:14"
    }
]

export const AllCameraData = [
    {
        "camera_name": "GATE TOWORDS PLANT",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "PPE Kit Detection"
            }
        }
    },
    {
        "camera_name": "GAS BANK & GARDEN ",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Safety Belt"
            }
        }
    },
    {
        "camera_name": "PLANT 1 PARKING",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Safety Goggles"
            }
        }
    },
    {
        "camera_name": "CANTEEN - 2",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Safety Shoes"
            }
        }
    },
    {
        "camera_name": "GATE TOWORDS OUTSIDE",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Fire Smoke"
            }
        }
    },
    {
        "camera_name": "GLOVES BACK SIDE",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Fire Smoke"
            }
        }
    },
    {
        "camera_name": "GRD TOILET SIDE",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Fire Smoke"
            }
        }
    },
    {
        "camera_name": "CANTEEN BACK SITE",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Fire Smoke"
            }
        }
    },
    {
        "camera_name": "NEAR RO PLANT",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "person lying on the floor"
            }
        }
    },
    {
        "camera_name": "Gate NO 2 OUTSIDE",
        "location_details": {
            "location_name": "Admin"
        },
        "ai_model_details": {
            "model_details": {
                "model_name": "Person Detection Common"
            }
        }
    }
]

export const AllCameraStatusData = [
    {
        "id": 233,
        "camera_name": "GLOVES ENTERANCE",
        "is_active": false,
        "location_details": {
            "location_name": "Gloves Production"
        }
    },
    {
        "id": 234,
        "camera_name": "P-2 TOILET TOP SIDE",
        "is_active": false,
        "location_details": {
            "location_name": "GMDCA Production"
        }
    },
    {
        "id": 235,
        "camera_name": "GATE TOWORDS PLANT",
        "is_active": false,
        "location_details": {
            "location_name": "Admin"
        }
    },
    {
        "id": 237,
        "camera_name": "B-2 DECCAN & SCORPIO",
        "is_active": false,
        "location_details": {
            "location_name": "GMDCA Production"
        }
    },
    {
        "id": 238,
        "camera_name": "GAS BANK & GARDEN ",
        "is_active": false,
        "location_details": {
            "location_name": "Admin"
        }
    },
    {
        "id": 240,
        "camera_name": "PLANT 1 PARKING",
        "is_active": true,
        "location_details": {
            "location_name": "Admin"
        }
    },
    {
        "id": 241,
        "camera_name": "SCRAP YARD PLANT 1",
        "is_active": false,
        "location_details": {
            "location_name": "Store"
        }
    },
    {
        "id": 242,
        "camera_name": "CANTEEN - 2",
        "is_active": false,
        "location_details": {
            "location_name": "Admin"
        }
    },
    {
        "id": 243,
        "camera_name": "ENGG STORE",
        "is_active": true,
        "location_details": {
            "location_name": "Store"
        }
    },
    {
        "id": 244,
        "camera_name": "PLANT -2 ENTRY GANGWAY",
        "is_active": false,
        "location_details": {
            "location_name": "GMDCA Production"
        }
    }
]

export const AllCameraLogStatusData = [
    {
        "id": 10470,
        "camera_id": 492,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:29:57",
        "camera_detail": {
            "camera_name": "CANTEEN 1"
        }
    },
    {
        "id": 10469,
        "camera_id": 490,
        "rtsp_status": true,
        "created_date": "2025-06-22T12:29:47",
        "camera_detail": {
            "camera_name": "SCRAPE AREA PLANT 2"
        }
    },
    {
        "id": 10468,
        "camera_id": 489,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:29:37",
        "camera_detail": {
            "camera_name": "LOADING & UNLOAD"
        }
    },
    {
        "id": 10467,
        "camera_id": 488,
        "rtsp_status": true,
        "created_date": "2025-06-22T12:29:27",
        "camera_detail": {
            "camera_name": "SCRAP YARD PLANT 2"
        }
    },
    {
        "id": 10466,
        "camera_id": 487,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:29:17",
        "camera_detail": {
            "camera_name": "Camera 01"
        }
    },
    {
        "id": 10465,
        "camera_id": 460,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:29:06",
        "camera_detail": {
            "camera_name": "H 14 BACK SIDE"
        }
    },
    {
        "id": 10464,
        "camera_id": 459,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:28:56",
        "camera_detail": {
            "camera_name": "EH12"
        }
    },
    {
        "id": 10463,
        "camera_id": 458,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:28:46",
        "camera_detail": {
            "camera_name": "BETWEEN EH-02 AND V4-V5 MACHIENE"
        }
    },
    {
        "id": 10462,
        "camera_id": 370,
        "rtsp_status": false,
        "created_date": "2025-06-22T12:28:36",
        "camera_detail": {
            "camera_name": "GRD FLR ENTRY"
        }
    },
    {
        "id": 10461,
        "camera_id": 369,
        "rtsp_status": true,
        "created_date": "2025-06-22T12:28:26",
        "camera_detail": {
            "camera_name": "PLANT 2 DOWN STREAM"
        }
    }
]

export const AllDeploymentJobsData = [
    {
        "image_size": "640",
        "confidence_threshold": "0.5",
        "iou_threshold": "0.3",
        "start_time": null,
        "end_time": null,
        "model_id": 57,
        "deployment_type_id": 2,
        "status": true,
        "id": 240,
        "created_date": "2025-04-29T06:08:13",
        "updated_date": "2025-04-29T06:08:13",
        "camera_settings": [
            {
                "rtsp_url": "rtsp://admin:Admin@123@202.179.70.26:1024/streaming/Channels/101",
                "camera_name": "Cam01",
                "camera_resolution": "640:640",
                "process_fps": 60,
                "location_id": 104,
                "camera_ip": "202.179.70.26",
                "is_active": true,
                "is_processing": true,
                "deployment_job_rtsp_id": 240,
                "is_tcp": true,
                "id": 496,
                "roi_type": false,
                "roi_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/123/ROI/496/Cam01.png",
                "status": true
            }
        ],
        "model_details": {
            "model_name": "Person Detection Common",
            "model_description": "This model will detect persons from given input images. This is the advanced version of existing model",
            "model_cpu_infer_speed": "0.11 ms",
            "model_gpu_infer_speed": "0.007 ms",
            "model_version_id": "1",
            "model_accuracy": "90",
            "model_size": "14 MB",
            "model_depth": "x",
            "framework_version_number": "v1",
            "model_type_id": 1,
            "model_device_id": 1,
            "model_framework_id": 1,
            "model_category_id": 2,
            "status": true,
            "id": 57,
            "created_date": "2021-01-24T18:32:25",
            "updated_date": "2021-01-24T18:32:25",
            "model_result_img": [
                {
                    "image_name": "gloves-detection",
                    "image_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-result-img/57/results/wider2_output.png",
                    "image_description": "This model will detect a red hat from given input images.",
                    "status": true,
                    "created_date": "2021-01-25T11:02:25",
                    "updated_date": "2021-01-25T11:02:25"
                },
                {
                    "image_name": "gloves-detection",
                    "image_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-result-img/57/results/wider3_output.png",
                    "image_description": "This model will detect a red hat from given input images.",
                    "status": true,
                    "created_date": "2021-01-25T11:02:25",
                    "updated_date": "2021-01-25T11:02:25"
                },
                {
                    "image_name": "gloves-detection",
                    "image_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-result-img/57/results/wider4_output.png\n",
                    "image_description": "This model will detect a red hat from given input images.",
                    "status": true,
                    "created_date": "2021-01-25T11:02:25",
                    "updated_date": "2021-01-25T11:02:25"
                }
            ],
            "model_s3_data": {
                "model_s3_url": "https://auto-serving-models.s3.ap-south-1.amazonaws.com/2020/mask-detection/",
                "model_s3_key": "as/person-detection-2/wider-person-model.pt",
                "model_s3_name": "best.pt",
                "model_version": "1",
                "created_date": "2020-10-12T10:30:16",
                "updated_date": "2020-10-12T10:30:16",
                "status": true
            },
            "model_training_settings": {
                "image_size": "416",
                "model_training_batch_size": "16",
                "batch_size": "16",
                "model_epochs": "50",
                "model_labels_list": "person",
                "created_date": "2020-10-12T10:29:02",
                "updated_date": "2020-10-12T10:29:02",
                "status": true
            },
            "model_banner_image": {
                "model_banner_image": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-banner-img/57/banner/wider1_output.png",
                "model_id": "57",
                "created_date": "2021-01-25T11:02:25",
                "updated_date": "2021-01-25T11:02:25",
                "status": true
            },
            "model_category_details": {
                "model_category_name": "Hygiene",
                "model_category_description": "This category includes all Hygiene related models",
                "id": 2,
                "created_date": "2021-08-16T10:29:37",
                "updated_date": "2021-08-16T11:25:37"
            },
            "user_id": null
        },
        "user_details": {
            "user_email": "megawide@hiro.ai",
            "user_status": true,
            "company_id": 96,
            "id": 123,
            "roles": [
                {
                    "role": "admin",
                    "id": 2
                }
            ],
            "company": {
                "company_email": "megawide@tusker.ai",
                "company_name": "megawide",
                "company_description": "megawide",
                "company_address": "philippines",
                "company_pin_code": "380006",
                "company_website": "https://megabytebohol.com/",
                "company_contact": "0384113164",
                "company_poc": "abcd",
                "company_poc_contact": "1234567890",
                "deployment_region": "ap-south-1",
                "id": 96,
                "created_date": "2025-04-25T13:44:12",
                "updated_date": "2025-04-25T13:44:12"
            },
            "locations": [],
            "companies": [],
            "created_date": "2025-04-25T13:44:13",
            "updated_date": "2025-04-25T13:44:13"
        },
        "deployment_type": {
            "deployment_type_name": "AI with IP-cameras",
            "deployment_type_description": "This deployement would take care of ip camera processing as well as the AI model.",
            "status": true,
            "id": 2,
            "created_date": "2020-09-24T20:54:19",
            "updated_date": "2021-04-24T07:23:49"
        }
    }
]

export const AllDeployedJobsData = [{
    "instance_id": "1",
    "instance_status": "",
    "api_endpoint": "",
    "deployment_job_rtsp_id": 240,
    "status": true,
    "id": 83,
    "created_date": "2024-12-06T08:56:43",
    "updated_date": "2024-12-06T08:56:43",
    "deployment_job_rtsp_details": {
        "image_size": "640",
        "confidence_threshold": "0.5",
        "iou_threshold": "0.3",
        "start_time": null,
        "end_time": null,
        "model_id": 57,
        "deployment_type_id": 2,
        "status": true,
        "id": 240,
        "created_date": "2025-04-29T06:08:13",
        "updated_date": "2025-04-29T06:08:13",
        "camera_settings": [
            {
                "rtsp_url": "rtsp://admin:Admin@123@202.179.70.26:1024/streaming/Channels/101",
                "camera_name": "Cam01",
                "camera_resolution": "640:640",
                "process_fps": 60,
                "location_id": 104,
                "camera_ip": "202.179.70.26",
                "is_active": true,
                "is_processing": true,
                "deployment_job_rtsp_id": 240,
                "is_tcp": true,
                "id": 496,
                "roi_type": false,
                "roi_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/123/ROI/496/Cam01.png",
                "status": true
            }
        ],
        "model_details": {
            "model_name": "Person Detection Common",
            "model_description": "This model will detect persons from given input images. This is the advanced version of existing model",
            "model_cpu_infer_speed": "0.11 ms",
            "model_gpu_infer_speed": "0.007 ms",
            "model_version_id": "1",
            "model_accuracy": "90",
            "model_size": "14 MB",
            "model_depth": "x",
            "framework_version_number": "v1",
            "model_type_id": 1,
            "model_device_id": 1,
            "model_framework_id": 1,
            "model_category_id": 2,
            "status": true,
            "id": 57,
            "created_date": "2021-01-24T18:32:25",
            "updated_date": "2021-01-24T18:32:25",
            "model_result_img": [
                {
                    "image_name": "gloves-detection",
                    "image_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-result-img/57/results/wider2_output.png",
                    "image_description": "This model will detect a red hat from given input images.",
                    "status": true,
                    "created_date": "2021-01-25T11:02:25",
                    "updated_date": "2021-01-25T11:02:25"
                },
                {
                    "image_name": "gloves-detection",
                    "image_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-result-img/57/results/wider3_output.png",
                    "image_description": "This model will detect a red hat from given input images.",
                    "status": true,
                    "created_date": "2021-01-25T11:02:25",
                    "updated_date": "2021-01-25T11:02:25"
                },
                {
                    "image_name": "gloves-detection",
                    "image_url": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-result-img/57/results/wider4_output.png\n",
                    "image_description": "This model will detect a red hat from given input images.",
                    "status": true,
                    "created_date": "2021-01-25T11:02:25",
                    "updated_date": "2021-01-25T11:02:25"
                }
            ],
            "model_s3_data": {
                "model_s3_url": "https://auto-serving-models.s3.ap-south-1.amazonaws.com/2020/mask-detection/",
                "model_s3_key": "as/person-detection-2/wider-person-model.pt",
                "model_s3_name": "best.pt",
                "model_version": "1",
                "created_date": "2020-10-12T10:30:16",
                "updated_date": "2020-10-12T10:30:16",
                "status": true
            },
            "model_training_settings": {
                "image_size": "416",
                "model_training_batch_size": "16",
                "batch_size": "16",
                "model_epochs": "50",
                "model_labels_list": "person",
                "created_date": "2020-10-12T10:29:02",
                "updated_date": "2020-10-12T10:29:02",
                "status": true
            },
            "model_banner_image": {
                "model_banner_image": "https://tusker-testing-images-storage.s3.ap-south-1.amazonaws.com/as/model-banner-img/57/banner/wider1_output.png",
                "model_id": "57",
                "created_date": "2021-01-25T11:02:25",
                "updated_date": "2021-01-25T11:02:25",
                "status": true
            },
            "model_category_details": {
                "model_category_name": "Hygiene",
                "model_category_description": "This category includes all Hygiene related models",
                "id": 2,
                "created_date": "2021-08-16T10:29:37",
                "updated_date": "2021-08-16T11:25:37"
            },
            "user_id": null
        },
        "user_details": {
            "user_email": "megawide@hiro.ai",
            "user_status": true,
            "company_id": 96,
            "id": 123,
            "roles": [
                {
                    "role": "admin",
                    "id": 2
                }
            ],
            "company": {
                "company_email": "megawide@tusker.ai",
                "company_name": "megawide",
                "company_description": "megawide",
                "company_address": "philippines",
                "company_pin_code": "380006",
                "company_website": "https://megabytebohol.com/",
                "company_contact": "0384113164",
                "company_poc": "abcd",
                "company_poc_contact": "1234567890",
                "deployment_region": "ap-south-1",
                "id": 96,
                "created_date": "2025-04-25T13:44:12",
                "updated_date": "2025-04-25T13:44:12"
            },
            "locations": [],
            "companies": [],
            "created_date": "2025-04-25T13:44:13",
            "updated_date": "2025-04-25T13:44:13"
        },
        "deployment_type": {
            "deployment_type_name": "AI with IP-cameras",
            "deployment_type_description": "This deployement would take care of ip camera processing as well as the AI model.",
            "status": true,
            "id": 2,
            "created_date": "2020-09-24T20:54:19",
            "updated_date": "2021-04-24T07:23:49"
        }
    }
}]

export const AllCompanyData = [
    {
        "company_id": 96,
        "company_name": "megawide",
        "company_email": "megawide@tusker.ai",
        "company_description": "megawide",
        "company_address": "philippines",
        "company_pin_code": "380006",
        "company_website": "https://megabytebohol.com/",
        "company_contact": "0384113164",
        "company_poc": "abcd",
        "company_poc_contact": "1234567890",
        "deployment_region": {id: "ap-south-1", label: "Mumbai"},
        "created_date": "2025-04-25T13:44:12",
        "updated_date": "2025-04-25T13:44:12",

        "users": [
            {
                "user_id": 1,
                "name": "Alice",
                "email": "alice@megawide.com",
                "role": "admin",
                "locations": [{
                    "location_id": 1,
                    "name": "Manila HQ",
                    "address": "123 Makati Ave",
                    "pin_code": "1000"
                }],
                "status": "active"
            },
            {
                "user_id": 2,
                "name": "Bob",
                "email": "bob@megawide.com",
                "role": "superadmin",
                "locations": [{
                    "location_id": 1,
                    "name": "Manila HQ",
                    "address": "123 Makati Ave",
                    "pin_code": "1000"
                },
                    {
                        "location_id": 2,
                        "name": "Cebu Branch",
                        "address": "456 Ayala St",
                        "pin_code": "6000"
                    }],
                "status": "active"
            },
            {
                "user_id": 3,
                "name": "Charlie",
                "email": "charlie@megawide.com",
                "role": "developer",
                "locations": [{
                    "location_id": 2,
                    "name": "Cebu Branch",
                    "address": "456 Ayala St",
                    "pin_code": "6000"
                }
                ],
                "status": "inactive"
            },
            {
                "user_id": 4,
                "name": "Diana",
                "email": "diana@megawide.com",
                "role": "developer",
                "locations": [{
                    "location_id": 1,
                    "name": "Manila HQ",
                    "address": "123 Makati Ave",
                    "pin_code": "1000"
                }],
                "status": "active"
            }
        ]
    }
]

export const AllRoleOptions = [
    {value: "admin", label: "Admin"},
    {value: "supervisor", label: "Supervisor"},
    {value: "developer", label: "Developer"},
]

export const deploymentRegionsData = [
    {id: 1, name: "Ohio", value: "us-east-2"},
    {id: 2, name: "N. Virginia", value: "us-east-1"},
    {id: 3, name: "N. California", value: "us-west-1"},
    {id: 4, name: "Oregon", value: "us-west-2"},
    {id: 5, name: "Cape Town", value: "af-south-1"},
    {id: 6, name: "Hong Kong", value: "ap-east-1"},
    {id: 7, name: "Mumbai", value: "ap-south-1"},
    {id: 8, name: "Osaka", value: "ap-northeast-3"},
    {id: 9, name: "Seoul", value: "ap-northeast-2"},
    {id: 10, name: "Singapore", value: "ap-southeast-1"},
    {id: 11, name: "Sydney", value: "ap-southeast-2"},
    {id: 12, name: "Tokyo", value: "ap-northeast-1"},
    {id: 13, name: "Central", value: "ca-central-1"},
    {id: 14, name: "Frankfurt", value: "eu-central-1"},
    {id: 15, name: "Ireland", value: "eu-west-1"},
    {id: 16, name: "London", value: "eu-west-2"},
    {id: 17, name: "Milan", value: "eu-south-1"},
    {id: 18, name: "Paris", value: "eu-west-3"},
    {id: 19, name: "Stockholm", value: "eu-north-1"},
    {id: 20, name: "Bahrain", value: "me-south-1"},
    {id: 21, name: "São Paulo", value: "sa-east-1"},
]

export const initialCompanyValues = {
    company_name: "",
    company_email: "",
    company_description: "",
    company_address: "",
    company_pin_code: "",
    company_website: "",
    company_contact: "",
    company_poc: "",
    company_poc_contact: "",
}

export const AllSubscriptionModelData = [
    {
        instance_id: 1,
        company_name: "megawide",
        user_email: "megawide@hiro.ai",
        user_role: "admin",
        model_name: "Person Detection Common",
        deployment_type: "AI with IP-cameras",
        deployment_status: true
    }
]

export const AllUserTypeOption = [
    {value: 1, label: "AI Pipeline"},
    {value: 2, label: "Store to Frame"},
]

export const AllCameraLabelMappingOption = [
    {

        "id": 1,
        "camera_name": "camera1",
        "labels": ["Helmet", "No Mask", "Reflective Vest"],
        "created_date": "2025-04-25T13:44:13",
        "updated_date": "2025-04-25T13:44:13",
        "user_details": {
            "user_email": "rpg_admin@tusker.ai",
            "user_status": true,
            "company_id": 79,
            "id": 97,
            "roles": [
                {
                    "role": "admin",
                    "id": 1
                }
            ],
            "company": {
                "company_email": "rpg_admin@tusker.ai",
                "company_name": "rpg",
                "company_description": "RPG",
                "company_address": "Naigaon East, Vasai-Virar, Bapane, Maharashtra 401208",
                "company_pin_code": "401208",
                "company_website": "https://www.rpggroup.com",
                "company_contact": "7456312192",
                "company_poc": "RPG",
                "company_poc_contact": "7456312192",
                "deployment_region": "ap-south-1",
                "id": 79,
                "created_date": "2024-04-04T07:17:39",
                "updated_date": "2024-04-04T07:17:39"
            },
        },
    }
]

export const AllStorageFrameData = [
    {
        instance_id: 1,
        company_name: "megawide",
        user_email: "megawide@hiro.ai",
        user_role: "admin",
        frame:[]
    }
]